import * as React from 'react';
import { Container, CurrentContainerStatus } from 'types/Watchlist';
import { StatusPill } from 'pages/Shipments/components/StatusPill/StatusPill';
import _ from 'lodash';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { SHIPMENTS_QUERY_PARAMS } from 'pages/Shipments/params';
import classNames from 'classnames';
import { ClickableCellProps, Column } from './types';

export const Status: React.FC<ClickableCellProps> = (props) => {
  const container = props.row as Container;
  const { pickupInfo } = container;

  const declarePickable = container.currentStatus === CurrentContainerStatus.AtTerminal;
  const availableForPickup =
    pickupInfo?.isAvailableForPickup && !pickupInfo.yardLocation.closedArea;

  const { searchParams } = useCustomSearchParams(SHIPMENTS_QUERY_PARAMS);
  const { focusedContainer } = searchParams;

  const isSelected = focusedContainer === container.containerNumber;

  return (
    <div
      className={classNames(
        'h-full w-full p-2 space-y-1 flex flex-col items-start justify-center',
        { 'cursor-pointer': !!props.onCellClick, 'border-2 border-blue-900 border-l-0': isSelected }
      )}
      onClick={(e) => {
        e.stopPropagation();
        props.onCellClick?.(container, Column.State);
      }}
    >
      <StatusPill status={container.currentStatus} />
      {!_.isNil(availableForPickup) &&
        declarePickable &&
        (availableForPickup ? (
          <h5 className="text-green text-center">Available for pickup</h5>
        ) : (
          <h5 className="text-red-900 text-center">Not available for pickup</h5>
        ))}
    </div>
  );
};
Status.displayName = 'Shipments.Table.Cells.Status';
